import { render } from "./AppModalDialog.vue?vue&type=template&id=11954de3&scoped=true"
import script from "./AppModalDialog.vue?vue&type=script&lang=js"
export * from "./AppModalDialog.vue?vue&type=script&lang=js"

import "./AppModalDialog.vue?vue&type=style&index=0&id=11954de3&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11954de3"]])

export default __exports__